module.exports = __webpack_public_path__ + "static/media/netflix.b2fcf3d6.jpeg";